import axios from 'axios';

const Axios = axios.create();
Axios.defaults.withCredentials = false;
Axios.defaults.timeout = 15000;

let publickParmas = {}

Axios.interceptors.request.use(
    config => {
        if (config.method === "post") {
            if (config.data instanceof FormData) {
                config.headers["Content-Type"] = "multipart/form-data";
            } else {
                config.headers["Content-Type"] =
                    "application/json; charset=UTF-8";
            }
            config.data = { ...config.data, ...publickParmas }
            config.headers = { ...config.headers }
        }
        return config;
    },
    err => {
        return Promise.reject(err);
    }
);
Axios.interceptors.response.use(
    res => {
        const result = res.data;
        return Promise.resolve(result);
        // if (result.code === 0) {
        //     return result;
        // }
        // return Promise.reject({
        //     message: `${result.code}: ${res.message}`,
        //     ...res
        // });
    },
    err => {
        return Promise.reject(err);
    }
);

export default Axios;